// extracted by mini-css-extract-plugin
export default {"themeSwitchContainer":"styles_themeSwitchContainer__njfPr","active":"styles_active__CMIKa"};